module.exports = __webpack_public_path__ + "img/warn.b8fac3ff.png";